import { useMutation, useQueryClient } from "@tanstack/react-query";

import stellar from "@/services/stellar";
import type { SupplierPayload, SupplierResource } from "../types";

const createSupplier = async (payload: SupplierPayload) => {
  const { supplier } = (await stellar.action("createSupplier", payload)) as {
    supplier: SupplierResource;
  };

  return supplier;
};

export const useCreateSupplierMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createSupplier,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["suppliers"] });
    },
  });
};
